import { render, staticRenderFns } from "./AdminDataExport.vue?vue&type=template&id=3a39e448&scoped=true"
import script from "./AdminDataExport.vue?vue&type=script&lang=js"
export * from "./AdminDataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39e448",
  null
  
)

export default component.exports